import logo from "../../../Assests/Frame 2147226168 (2).svg";
import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import axios from "axios";
import { EyeOutlined, LeftOutlined } from "@ant-design/icons";
import { SERVICE_URL } from "../../../common/api.js";
import styled from "styled-components";
import { ReactComponent as CautionValidation } from "../../../Assests/cautionvalidation.svg";
import { Input } from "antd";
import { Col, Row } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { isValidEmail } from "../../../Utilities/helper.js";

const { Password } = Input;

const NewBox = styled.div`
  .backgroundStyle {
    padding: 3px !important;
  }
  .customized_container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .customized_container_one {
    width: 33%;
    height: 600px;
  }
  .signing_in {
    color: #5f6d8c;
    margin-top: 40px;
  }
  .login-error-msg {
    background-color: #f37c7c24;
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    gap: 17px;
    padding: 5px 5px 5px 15px;
    border: 2px solid #f48484;
  }
  .errorvalidation_msg {
    margin: 0px;
    font-size: 0.9rem;
  }
  .password_field {
    background-color: rgb(232, 240, 254);
    padding: 9px;
    border: none;
    border-radius: 22px;
  }
`;

const backgroundStyle = {
  backgroundImage: `url(https://trackright-v2.s3.ap-south-1.amazonaws.com/images/Bglogoimg.jpeg)`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  height: "100vh",
  width: "100%",
  padding: "20px!important",
};

const greenBtnStyle = {
  cursor: "pointer",
  backgroundColor: "green",
  border: "none",
  color: "white",
  width: "50%",
  borderRadius: "25px",
};

const backToLoginStyle = {
  cursor: "pointer",
  fontSize: "14px",
  color: "#2e7d32",
};

const leftIconStyle = {
  color: "#2c963d",
  width: "15px",
  marginRight: "12px",
};

const GLOBAL_STYLES = `
  .login-header {
    font-weight: 500;
    font-size: 24px;
    color: #5F6D8C;
  }
  .otp-input {
    width: 30px !important;
    height: 45px;
    // margin: 0 5px;
    border-radius: 12px;
    border: 1px solid #ddd;
    text-align: center;
    // font-size: 18px;
    outline: none;
  }
  .otp-input:focus {
    border-color: #2C963D;
    box-shadow: 0 0 5px rgba(46,125,50,0.3);
  }
  .resend-text {
    color: #2C963D;
    font-size: 14px;
    cursor: pointer;
  }
  .back-btn, .back-btn:disabled {
    background: #E8FFEC;
    color: #2C963D;
    border-radius: 25px;
    padding: 6px 30px;
    border: none;
  }
  .back-btn:hover { background: #baf5c4; }
  .verify-btn, .verify-btn:disabled {
    background: #2C963D;
    color: white;
    border-radius: 25px;
    padding: 6px 30px;
    border: none;
  }
  .verify-btn:hover {
    background: #0c611a;
    color: white;
  }
`;

const EyeIcon = () => <EyeOutlined />;

const BackToLogin = ({ onClick }) => (
  <p onClick={onClick} style={backToLoginStyle}>
    <LeftOutlined style={leftIconStyle} />
    Back to Login Page
  </p>
);

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
    verifyOtp: "",
  });
  const [reSendingOtp, setResendingOtp] = useState(false);

  useEffect(() => {
    if (!errorMsg) return;
    const timer = setTimeout(() => {
      setErrorMessage("");
      setErrorMsg(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, [errorMsg]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/login",
        { IDorMail: email, Password: password },
      );
      if (response?.status === 200) {
        setTimeout(() => {
          window.location.href = `https://www.uat.v2.app.trackright.africa/?token=${response.data.data.token}`;
        }, 1000);
      }
    } catch (err) {
      setErrorMessage(
        err.response?.data?.message ||
          "The password you entered is incorrect. Please check and try again.",
      );
      setErrorMsg(true);
    } finally {
      setLoading(false);
    }
  };

  const validatePasswords = () => {
    const newErrors = { newPassword: "", confirmPassword: "" };
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return !newErrors.newPassword && !newErrors.confirmPassword;
  };

  const handleSubmitConfirmPassword = async () => {
    if (!validatePasswords()) return;
    setLoading(true);
    try {
      const identifierPayload = forgotEmail.includes("@")
        ? { email: forgotEmail }
        : { userId: forgotEmail };
      const response = await axios.post(
        `${SERVICE_URL}account/forgot-password/reset`,
        { ...identifierPayload, newPassword, confirmPassword },
      );
      if (response.status === 200) {
        setShowNewPasswordModal(false);
        setIsForgotPassword(false);
        setNewPassword("");
        setConfirmPassword("");
        // alert("Password reset successfully.");
      }
    } catch {
      setError("An error occurred while resetting the password.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e?.preventDefault();
    if (!forgotEmail) return setError("Email or User ID is required");
    if (forgotEmail.includes("@") && !isValidEmail(forgotEmail))
      return setError("Please enter a valid email address");

    setResendingOtp(true);
    setError("");
    setOtp("");
    setErrors((prev) => ({ ...prev, verifyOtp: "" }));
    try {
      const payload = forgotEmail.includes("@")
        ? { email: forgotEmail }
        : { userId: forgotEmail };
      const response = await axios.post(
        `${SERVICE_URL}account/forgot-password/send-otp`,
        payload,
      );
      if (response.status === 200) {
        // alert("OTP sent to your email.");
        setErrors((prev) => ({ ...prev, verifyOtp: "" }));
        setShowOtpModal(true);
      }
    } catch {
      setError("OTP cannot be sent. Please check your email or User ID.");
    } finally {
      setResendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setErrors((prev) => ({
        ...prev,
        verifyOtp: "Please enter a valid 6-digit OTP.",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, verifyOtp: "" }));
    setLoading(true);
    try {
      const identifierPayload = forgotEmail.includes("@")
        ? { email: forgotEmail }
        : { userId: forgotEmail };
      const response = await axios.post(
        `${SERVICE_URL}account/forgot-password/verify-otp`,
        { ...identifierPayload, otp },
      );
      if (response.status === 200) {
        setShowOtpModal(false);
        setShowNewPasswordModal(true);
        setOtp("");
        // alert("OTP verified successfully.");
      }
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        verifyOtp:
          err?.response?.data?.message ||
          "An error occurred while verifying the OTP.",
      }));
    } finally {
      setLoading(false);
    }
  };

  const togglePage = () => {
    setIsForgotPassword((prev) => !prev);
    setError("");
    setShowOtpModal(false);
    setShowNewPasswordModal(false);
    setForgotEmail("");
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({ newPassword: "", confirmPassword: "", verifyOtp: "" });
  };

  const handleNavigate = () => {
    window.open("https://trackright.africa/privacy-policy/", "_blank");
  };

  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
  };
  const width = useWindowWidth();

  return (
    <>
      <style>{GLOBAL_STYLES}</style>
      <NewBox>
        <div
          className="login p-5 vh-100 backgroundStyle"
          style={backgroundStyle}
        >
          {showOtpModal ? (
            <div
              style={{
                backgroundColor: "white",
                padding: "15px 14px 15px 14px",
                borderRadius: "12px",
                maxWidth: "400px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "15%",
              }}
            >
              <>
                <span className="d-flex justify-content-center align-items-center">
                  <img src={logo} alt="logo" width="242" height="45" />
                </span>
                <h5
                  style={{ fontSize: width <= 426 ? "11px" : "24px" }}
                  className="my-4 text-secondary login-header text-center"
                >
                  Enter OTP to Change Password
                </h5>
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexWrap: width <= 426 ? "nowrap" : "nowrap",
                    background: "",
                  }}
                  className="d-flex justify-content-center mb-3"
                >
                  <OtpInput
                    containerStyle={
                      {
                        // display: "flex",
                        // flexWrap: "wrap",
                        // justifyContent: "center",
                        // alignItems: "center",
                        // gap: "3px",
                        // width: width <= 426 ? "20px" : "",
                        // height: width <= 426 ? "30px" : "",
                      }
                    }
                    inputStyle={{
                      width: width <= 426 ? "16px" : "20px",
                      height: width <= 426 ? "40px" : "45px",
                      // fontSize: width <= 426 ? "14px" : "18px",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span className="mx-1" />}
                    renderInput={(props) => (
                      <input {...props} className="otp-input" />
                    )}
                  />
                </div>
                {errors.verifyOtp && (
                  <p className="text-danger mt-1">{errors.verifyOtp}</p>
                )}
                <div className="text-start mb-4">
                  <span
                    className="resend-text"
                    onClick={handleForgotPassword}
                    disabled={reSendingOtp}
                  >
                    {reSendingOtp ? "Sending..." : " ⟳ Resend OTP"}
                  </span>
                </div>
                <div className="d-flex justify-content-center gap-3 mb-4">
                  <button
                    className="btn back-btn"
                    onClick={() => setShowOtpModal(false)}
                    disabled={loading || reSendingOtp}
                  >
                    Back
                  </button>
                  <button
                    className="btn verify-btn"
                    onClick={handleVerifyOtp}
                    disabled={loading || reSendingOtp}
                  >
                    {loading ? "Verifying..." : "Verify"}
                  </button>
                </div>
                <BackToLogin onClick={togglePage} />
              </>
            </div>
          ) : null}

          <Row>
            <div className="customized_container">
              <Col xl={4} />
              <Col
                xl={4}
                style={{ width: "600px", height: "100%", marginTop: "10%" }}
              >
                {console.log("Width:", width)}
                <Spin spinning={loading}>
                  {showOtpModal ? null : (
                    <div
                      style={{
                        width:
                          width <= 375 ? "315px" : width <= 375 ? "380px" : "",
                        margin: "0 auto",
                      }}
                      className="logo-card bg-white p-4 rounded-4"
                    >
                      {showOtpModal ? null : (
                        <span className="d-flex justify-content-center align-items-center">
                          <img src={logo} alt="logo" width="242" height="45" />
                        </span>
                      )}
                      {/* ── FORGOT PASSWORD FLOW ── */}
                      {isForgotPassword ? (
                        <>
                          {showOtpModal ? (
                            <>
                              {/* <>
                            <h5 className="my-4 text-secondary login-header text-center">
                              Enter OTP to Change Password
                            </h5>
                            <div
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                flexWrap: width <= 426 ? "wrap" : "nowrap",
                                background: "",
                              }}
                              className="d-flex justify-content-center mb-3"
                            >
                              <OtpInput
                                containerStyle={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "",
                                  gap: "3px",
                                }}
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span className="mx-1" />}
                                renderInput={(props) => (
                                  <input {...props} className="otp-input" />
                                )}
                              />
                            </div>
                            {errors.verifyOtp && (
                              <p className="text-danger mt-1">
                                {errors.verifyOtp}
                              </p>
                            )}
                            <div className="text-start mb-4">
                              <span
                                className="resend-text"
                                onClick={handleForgotPassword}
                                disabled={reSendingOtp}
                              >
                                {reSendingOtp ? "Sending..." : " ⟳ Resend OTP"}
                              </span>
                            </div>
                            <div className="d-flex justify-content-center gap-3 mb-4">
                              <button
                                className="btn back-btn"
                                onClick={() => setShowOtpModal(false)}
                                disabled={loading || reSendingOtp}
                              >
                                Back
                              </button>
                              <button
                                className="btn verify-btn"
                                onClick={handleVerifyOtp}
                                disabled={loading || reSendingOtp}
                              >
                                {loading ? "Verifying..." : "Verify"}
                              </button>
                            </div>
                            <BackToLogin onClick={togglePage} />
                          </> */}
                            </>
                          ) : showNewPasswordModal ? (
                            <>
                              <h5 className="my-4 text-secondary login-header text-center">
                                Enter New Password
                              </h5>
                              <div className="text-start mb-3">
                                <label className="form-label">
                                  New Password
                                </label>
                                <Password
                                  placeholder="Enter your password"
                                  iconRender={EyeIcon}
                                  className="password_field"
                                  value={newPassword}
                                  onChange={(e) =>
                                    setNewPassword(e.target.value)
                                  }
                                />
                                {errors.newPassword && (
                                  <p className="text-danger mt-1">
                                    {errors.newPassword}
                                  </p>
                                )}
                              </div>
                              <div className="text-start mb-4">
                                <label className="form-label">
                                  Confirm Password
                                </label>
                                <Password
                                  placeholder="Confirm your password"
                                  iconRender={EyeIcon}
                                  className="password_field"
                                  value={confirmPassword}
                                  onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                  }
                                />
                                {errors.confirmPassword && (
                                  <p className="text-danger mt-1">
                                    {errors.confirmPassword}
                                  </p>
                                )}
                              </div>
                              <div className="text-center">
                                <button
                                  className="btn mb-4"
                                  style={greenBtnStyle}
                                  onClick={handleSubmitConfirmPassword}
                                  disabled={loading}
                                >
                                  Confirm
                                </button>
                              </div>
                              <BackToLogin onClick={togglePage} />
                            </>
                          ) : (
                            <>
                              <h3 className="login-header text-center pt-4">
                                Forgot Password
                              </h3>
                              <form
                                className="p-3"
                                onSubmit={handleForgotPassword}
                              >
                                <div className="mb-3 text-color">
                                  <label htmlFor="forgotEmail">
                                    Email or User ID
                                  </label>
                                  <input
                                    id="forgotEmail"
                                    type="text"
                                    placeholder="Enter your Email or User ID"
                                    className="form-control rounded-pill"
                                    value={forgotEmail}
                                    onChange={(e) =>
                                      setForgotEmail(e.target.value)
                                    }
                                  />
                                </div>
                                {error && (
                                  <p className="text-danger">{error}</p>
                                )}
                                <div className="text-center pt-4 mt-2 pb-2">
                                  <button
                                    style={greenBtnStyle}
                                    className="form-btn"
                                    type="submit"
                                    disabled={loading}
                                  >
                                    {loading ? "Loading..." : "Send OTP"}
                                  </button>
                                </div>
                              </form>
                              <BackToLogin onClick={togglePage} />
                            </>
                          )}
                        </>
                      ) : (
                        /* ── LOGIN FLOW ── */
                        <>
                          <h3 className="login-header text-center pt-4">
                            Sign in
                          </h3>
                          {errorMsg && (
                            <div className="login-error-msg">
                              <CautionValidation />
                              <p className="errorvalidation_msg mb-0">
                                {errorMessage}
                              </p>
                            </div>
                          )}
                          <form onSubmit={handleLogin} className="p-3">
                            <div className="mb-3 text-color">
                              <label htmlFor="email">User ID or Email</label>
                              <input
                                id="email"
                                type="text"
                                placeholder="Enter your Email"
                                className="form-control rounded-pill"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>
                            <div className="mb-3 text-color">
                              <label htmlFor="password">Password</label>
                              <Password
                                placeholder="Enter your password"
                                iconRender={EyeIcon}
                                className="password_field"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                              />
                            </div>
                            <p
                              className="text-secoundcolor"
                              onClick={togglePage}
                              style={{ cursor: "pointer", color: "#2e7d32" }}
                            >
                              Forgot Password?
                            </p>
                            <p className="signing_in">
                              By signing in, you agree to our&nbsp;
                              <span
                                onClick={handleNavigate}
                                style={{
                                  color: "green",
                                  cursor: "pointer",
                                  borderBottom: "2px solid green",
                                }}
                              >
                                Privacy Policy
                              </span>
                            </p>
                            <div className="text-center pt-4 mt-2 pb-2">
                              <button
                                style={greenBtnStyle}
                                className="form-btn"
                                type="submit"
                                disabled={loading}
                              >
                                {loading ? "Loading..." : "Sign In"}
                              </button>
                            </div>
                          </form>
                        </>
                      )}
                    </div>
                  )}
                </Spin>
              </Col>
              <Col xl={4} />
            </div>
          </Row>
        </div>
      </NewBox>
    </>
  );
};

export default Login;
